<template>
  <div class="quantity-wrapper">
    <div class="quantity-section">
      <label>{{ $t("message.payments.locationsQuantity") }}</label>
      <div class="number-field" :class="{ 'is-disabled': +price === 0 }">
        <button
          class="number-field__btn"
          :disabled="+price === 0"
          @click="handleDecrease"
        >
          <v-icon>mdi-minus</v-icon>
        </button>
        <input
          v-model="localQuantity"
          type="number"
          class="number-field__input"
          :disabled="+price === 0"
        />
        <button
          class="number-field__btn"
          :disabled="+price === 0"
          @click="handleIncrease"
        >
          <v-icon>mdi-plus</v-icon>
        </button>
      </div>
    </div>
    <span class="quantity-section__secondary-text">{{
      $t("message.payments.perLocation", [`${pricePerUnit} ${currency}`])
    }}</span>
  </div>
</template>

<script>
export default {
  name: "QuantitySelector",
  props: {
    value: {
      type: Number,
      required: true
    },
    pricePerUnit: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      localQuantity: 1,
      initialAssignmentDone: false
    };
  },
  computed: {
    currency() {
      return this.$store.state.payments.currency;
    },
    price() {
      return `${this.$store.getters["payments/price"]}`;
    }
  },
  created() {
    this.localQuantity = this.value;
    this.initialAssignmentDone = true;
  },
  methods: {
    handleIncrease() {
      this.initialAssignmentDone = false;
      if (this.localQuantity < 20) {
        this.localQuantity++;
      }
    },
    handleDecrease() {
      this.initialAssignmentDone = false;
      if (this.localQuantity > 1) {
        this.localQuantity--;
      }
    }
  },
  watch: {
    localQuantity(value) {
      if (value > 20) {
        this.localQuantity = 20;
      }
      if (value < 1) {
        this.localQuantity = 1;
      }
      if (!this.initialAssignmentDone) {
        this.$emit("input", value);
      }
    },
    price(current) {
      if (+current !== 0) return;
      this.localQuantity = 1;
      this.$emit("input", 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.quantity-wrapper {
  display: flex;
  align-items: flex-end;
  gap: $spacing;
}

.number-field {
  display: flex;
  align-items: center;
  background: white;
  height: 46px;
  border-radius: 6px;
  text-align: center;
  max-width: 220px;
  overflow: hidden;

  &.is-disabled {
    .number-field__btn,
    .number-field__input {
      background: darken($gray-100, 3%);
      .v-icon {
        color: $dark-blue-3;
      }
    }
  }

  &__btn {
    height: 100%;
    width: 46px;
    transition: background 0.1s;
    flex-shrink: 0;

    .v-icon {
      color: $primary;
    }

    &:hover {
      background: $gray-500;
    }

    &:first-of-type {
      border-radius: 6px 0 0 6px;
      border-top: 1px solid $gray-300;
      border-left: 1px solid $gray-300;
      border-bottom: 1px solid $gray-300;
    }
    &:last-of-type {
      border-radius: 0 6px 6px 0;
      border-top: 1px solid $gray-300;
      border-right: 1px solid $gray-300;
      border-bottom: 1px solid $gray-300;
    }
  }

  &__input {
    height: 100%;
    text-align: center;
    border: 1px solid $gray-300;
    width: 100%;
    font-weight: 600;

    &:focus {
      outline: none;
      border-color: $primary;
    }

    &[type="number"] {
      -moz-appearance: textfield;
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
  }
}
.quantity-section {
  display: flex;
  flex-direction: column;
  gap: $spacing * 0.5;
  @include font-size(14px);

  &__secondary-text {
    @include font-size(14px);
    color: $gray;
  }
}
</style>
